import { render, staticRenderFns } from "./NewPostBox.vue?vue&type=template&id=28106f2e&"
import script from "./NewPostBox.vue?vue&type=script&lang=js&"
export * from "./NewPostBox.vue?vue&type=script&lang=js&"
import style0 from "./NewPostBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports